import React, { useState } from "react";
// import alg1 from "../../docpdf/X SSC ALG PRAC PAPER 1.pdf";
// import alg2 from "../../docpdf/X SSC ALG PRAC PAPER 2.pdf";
// import alg3 from "../../docpdf/X SSC ALG PRAC PAPER 3.pdf";

// import eng1 from "../../docpdf/X SSC ENG PRAC PAPER 1.pdf";
// import eng2 from "../../docpdf/X SSC ENG PRAC PAPER 2.pdf";
// import eng3 from "../../docpdf/X SSC ENG PRAC PAPER 3.pdf";

// import geog1 from "../../docpdf/X SSC GEOG PRAC PAPER 1.pdf";
// import geog2 from "../../docpdf/X SSC GEOG PRAC PAPER 2.pdf";
// import geog3 from "../../docpdf/X SSC GEOG PRAC PAPER 3.pdf";

// import geom1 from "../../docpdf/X SSC GEOM PRAC PAPER 1.pdf";
// import geom2 from "../../docpdf/X SSC GEOM PRAC PAPER 2.pdf";
// import geom3 from "../../docpdf/X SSC GEOM PRAC PAPER 3.pdf";

// import hist1 from "../../docpdf/X SSC HIST PRAC PAPER 1.pdf";
// import hist2 from "../../docpdf/X SSC HIST PRAC PAPER 2.pdf";
// import hist3 from "../../docpdf/X SSC HIST PRAC PAPER 3.pdf";

// import mar1 from "../../docpdf/X SSC MAR PRAC PAPER 1.pdf";
// import mar2 from "../../docpdf/X SSC MAR PRAC PAPER 2.pdf";
// import mar3 from "../../docpdf/X SSC MAR PRAC PAPER 3.pdf";

// import sci1 from "../../docpdf/X SSC SC 1 PRAC PAPER 1.pdf";
// import sci2 from "../../docpdf/X SSC SC 1 PRAC PAPER 2.pdf";
// import sci5 from "../../docpdf/X SSC SC 1 PRAC PAPER 3.pdf";

// import sci3 from "../../docpdf/X SSC SC 2 PRAC PAPER 1.pdf";
// import sci4 from "../../docpdf/X SSC SC 2 PRAC PAPER 2.pdf";
// import sci6 from "../../docpdf/X SSC SC 2 PRAC PAPER 3.pdf";

// import snk1 from "../../docpdf/X-SSC-SK 100 PRAC PAPER 1.pdf";
// import snk2 from "../../docpdf/X-SSC-SK 100 PRAC PAPER 2.pdf";
// import snk3 from "../../docpdf/X-SSC-SK 100 PRAC PAPER 3.pdf";

// import snk4 from "../../docpdf/X-SSC-SK 50 PRAC PAPER 1.pdf";
// import snk5 from "../../docpdf/X-SSC-SK 50 PRAC PAPER 2.pdf";
// import snk6 from "../../docpdf/X-SSC-SK 50 PRAC PAPER 3.pdf";

// import hin1 from "../../docpdf/X-SSC-HIN 100 PRAC PAPER 1.pdf";
// import hin2 from "../../docpdf/X-SSC-HIN 100 PRAC PAPER 2.pdf";
// import hin3 from "../../docpdf/X-SSC-HIN 100 PRAC PAPER 3.pdf";

// import hin4 from "../../docpdf/X-SSC-HIN 50 PRAC PAPER 1.pdf";
// import hin5 from "../../docpdf/X-SSC-HIN 50 PRAC PAPER 2.pdf";
// import hin6 from "../../docpdf/X-SSC-HIN 50 PRAC PAPER 3.pdf";

// import fr1 from "../../docpdf/X-SSC-FR 50 PRAC PAPER 1.pdf";
// import fr2 from "../../docpdf/X-SSC-FR 50 PRAC PAPER 2.pdf";

export default function Sscpaper() {
  const [data, setData] = useState([
     { id: 1, heading: "X SSC Marathi Sample paper 1", pdf: require('../../docpdf/2026/Marathi_SP1.pdf') },
     { id: 2, heading: "X SSC Marathi Sample paper 2", pdf: require('../../docpdf/2026/Marathi_SP2.pdf') },
     { id: 3, heading: "X SSC Marathi Sample paper 3", pdf: require('../../docpdf/2026/Marathi_SP3.pdf') },
     { id: 7, heading: "X SSC Sanskrit 50 Sample paper 1", pdf: require('../../docpdf/2026/Sanskrit_50_SP1.pdf') },
     { id: 8, heading: "X SSC Sanskrit 50 Sample paper 2", pdf: require('../../docpdf/2026/Sanskrit_50_SP2.pdf') },
     { id: 9, heading: "X SSC Sanskrit 50 Sample paper 3", pdf: require('../../docpdf/2026/Sanskrit_50_SP3.pdf') },
     { id: 10, heading: "X SSC Sanskrit 100 Sample paper 1", pdf: require('../../docpdf/2026/Sanskrit_100_SP1.pdf') },
     { id: 11, heading: "X SSC Sanskrit 100 Sample paper 2", pdf: require('../../docpdf/2026/Sanskrit_100_SP2.pdf') },
     { id: 12, heading: "X SSC Sanskrit 100 Sample paper 3", pdf: require('../../docpdf/2026/Sanskrit_100_SP3.pdf') },
     { id: 12, heading: "X SSC Science 1 Sample paper 1", pdf: require('../../docpdf/2026/Science_1_SP1.pdf') },
     { id: 13, heading: "X SSC Science 1 Sample paper 2", pdf: require('../../docpdf/2026/Science_1_SP2.pdf') },
     { id: 14, heading: "X SSC Science 1 Sample paper 3", pdf: require('../../docpdf/2026/Science_1_SP3.pdf') },
     { id: 15, heading: "X SSC Science 2 Sample paper 1", pdf: require('../../docpdf/2026/English_SP1.pdf') },
     { id: 16, heading: "X SSC Science 2 Sample paper 2", pdf: require('../../docpdf/2026/Science_2_SP2.pdf') },
     { id: 17, heading: "X SSC Science 2 Sample paper 3", pdf: require('../../docpdf/2026/Science_2_SP3.pdf') },
     { id: 18, heading: "X SSC English Kumarbharati Sample paper 1", pdf: require('../../docpdf/2026/English_SP1.pdf') },
     { id: 19, heading: "X SSC English Kumarbharati Sample paper 2", pdf: require('../../docpdf/2026/English_SP2.pdf') },
     { id: 20, heading: "X SSC English Kumarbharati Sample paper 3", pdf: require('../../docpdf/2026/English_SP3.pdf') },
     { id: 18, heading: "X SSC Algebra Sample paper 1", pdf: require('../../docpdf/2026/Algebra_SP1.pdf') },
     { id: 19, heading: "X SSC Algebra Sample paper 2", pdf: require('../../docpdf/2026/Algebra_SP2.pdf') },
     { id: 20, heading: "X SSC Algebra Sample paper 3", pdf: require('../../docpdf/2026/Algebra_SP3.pdf') },
     { id: 18, heading: "X SSC Geography paper 1", pdf: require('../../docpdf/2026/Geography_SP1.pdf') },
     { id: 19, heading: "X SSC Geography paper 2", pdf: require('../../docpdf/2026/Geography_SP2.pdf') },
     { id: 20, heading: "X SSC Geography paper 3", pdf: require('../../docpdf/2026/Geography_SP3.pdf') },
     { id: 18, heading: "X SSC French paper 1", pdf: require('../../docpdf/2026/French_SP1.pdf') },
     { id: 19, heading: "X SSC French paper 2", pdf: require('../../docpdf/2026/French_SP2.pdf') },
     { id: 18, heading: "X SSC Geometry paper 1", pdf: require('../../docpdf/2026/Geometry_SP1.pdf') },
     { id: 19, heading: "X SSC Geometry paper 2", pdf: require('../../docpdf/2026/Geometry_SP2.pdf') },
     { id: 20, heading: "X SSC Geometry paper 3", pdf: require('../../docpdf/2026/Geometry_SP3.pdf') },
     { id: 18, heading: "X SSC German paper 1", pdf: require('../../docpdf/2026/German_SP1.pdf') },
     { id: 19, heading: "X SSC German paper 2", pdf: require('../../docpdf/2026/German_SP2.pdf') },
     { id: 20, heading: "X SSC German paper 3", pdf: require('../../docpdf/2026/German_SP3.pdf') },
     { id: 18, heading: "X SSC Hindi 50 paper 1", pdf: require('../../docpdf/2026/Hindi50_SP1.pdf') },
     { id: 19, heading: "X SSC Hindi 50 paper 2", pdf: require('../../docpdf/2026/Hindi50_SP2.pdf') },
     { id: 20, heading: "X SSC Hindi 50 paper 3", pdf: require('../../docpdf/2026/Hindi50_SP3.pdf') },
     { id: 18, heading: "X SSC Hindi 100 paper 1", pdf: require('../../docpdf/2026/Hindi100_SP1.pdf') },
     { id: 19, heading: "X SSC Hindi 100 paper 2", pdf: require('../../docpdf/2026/Hindi100_SP2.pdf') },
     { id: 20, heading: "X SSC Hindi 100 paper 3", pdf: require('../../docpdf/2026/Hindi100_SP3.pdf') },
     { id: 18, heading: "X SSC History & PS paper 1", pdf: require('../../docpdf/2026/History&PS_SP1.pdf') },
     { id: 19, heading: "X SSC History & PS paper 2", pdf: require('../../docpdf/2026/History&PS_SP2.pdf') },
     { id: 20, heading: "X SSC History & PS paper 3", pdf: require('../../docpdf/2026/History&PS_SP3.pdf') },
     
  ]);
  return (
    <>
      <div className="papermaindiv">
        {data.map((item, index) => {
          return (
            <a href={item.pdf} target="_blank">
              <div className="papersection">
                <h1 className="paperheading">{item.heading}</h1>
              </div>
            </a>
          );
        })}
      </div>
    </>
  );
}
